import axiosInstance from './axiosInstance';

/** Notificaciones no leídas del usuario logueado (el destinatario sale del token). */
export async function getNoLeidas() {
  const res = await axiosInstance.get('/notificaciones/no_leidas');
  return res.data.data;
}

/** Notificaciones ya leídas del usuario logueado. */
export async function getLeidas() {
  const res = await axiosInstance.get('/notificaciones/leidas');
  return res.data.data;
}

/** Marca una notificación como leída. */
export async function marcarLeida(id) {
  const res = await axiosInstance.patch(`/notificaciones/${id}/leer`);
  return res.data.data;
}

/** Marca como leídas todas las notificaciones no leídas del usuario. */
export async function marcarTodasLeidas() {
  const res = await axiosInstance.patch('/notificaciones/leer_todas');
  return res.data.data;
}
